import { ApplicationValidationType } from '@/types/application';
import { IUserWithProfile } from '@/types/user';
import { Typography } from '@mui/material';

type StudentOverviewRowProps = {
  user: IUserWithProfile;
  validationType: ApplicationValidationType;
};

export function StudentOverviewRow({
  user,
  validationType,
}: StudentOverviewRowProps) {
  const userName = [user.firstName, user.lastName].filter(Boolean).join(' ');

  const showLinkedIn =
    validationType === ApplicationValidationType.Skills ||
    validationType === ApplicationValidationType.AdmissionProcess;
  const showJobRole =
    validationType === ApplicationValidationType.Capacity ||
    validationType === ApplicationValidationType.AdmissionProcess;

  return (
    <div>
      <Typography variant="subtitle1" className="mb-2 font-semibold">
        Student's Overview
      </Typography>
      <div className="grid grid-cols-3 gap-2 bg-light-gray p-4 rounded-xl">
        <div className="flex flex-col">
          <Typography fontWeight={600}>{userName}</Typography>
          <Typography variant="body2" color="text.primary">
            {user.email}
          </Typography>
        </div>
        {showLinkedIn && user.profile?.linkedInUrl && (
          <div className="flex flex-col">
            <Typography fontWeight={600}>LinkedIn</Typography>
            <Typography variant="body2" color="text.primary">
              <a
                href={user.profile.linkedInUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                {user.profile.linkedInUrl}
              </a>
            </Typography>
          </div>
        )}
        {showJobRole && user.profile?.currentRole && (
          <div className="flex flex-col">
            <Typography fontWeight={600}>Job role</Typography>
            <Typography variant="body2" color="text.primary">
              {user.profile.currentRole}
            </Typography>
          </div>
        )}
        <div className="flex flex-col col-span-3">
          <Typography fontWeight={600}>Skills</Typography>
          <Typography variant="body2" color="text.primary">
            {user.profile?.skills?.length
              ? user.profile.skills.join(', ')
              : '(none)'}
          </Typography>
        </div>
      </div>
    </div>
  );
}
